import FIELD_TYPE from 'Component/Field/Field.config';
import {
    MyAccountAddressForm as SourceMyAccountAddressForm
} from 'SourceComponent/MyAccountAddressForm/MyAccountAddressForm.component';

import myAccountAddressForm from './MyAccountAddressForm.form';
/** @namespace Bodypwa/Component/MyAccountAddressForm/Component */
export class MyAccountAddressFormComponent extends SourceMyAccountAddressForm {
    // TODO implement logic
    // #region GETTERS
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    get fieldMap() {
        const {
            address,
            countries,
            addressLinesQty,
            regionDisplayAll,
            showVatNumber,
            defaultCountry,
            availableRegions,
            isStateRequired,
            countryId,
            currentRegion,
            currentCity,
            currentRegionId,
            currentZipcode,
            onCountryChange,
            onZipcodeChange,
            onCityChange,
            onRegionChange,
            onRegionIdChange,
            firstname,
            lastname,
            telephone,
            region_id,
            postcode,
            city,
            region
        } = this.props;

        return myAccountAddressForm({
            countries,
            addressLinesQty,
            regionDisplayAll,
            showVatNumber,
            defaultCountry,
            availableRegions,
            isStateRequired,
            countryId,
            currentRegion,
            currentCity,
            currentRegionId,
            currentZipcode,
            firstname,
            lastname,
            telephone,
            region_id,
            postcode,
            city,
            region,
            address,
            ...address
        }, {
            onCountryChange,
            onZipcodeChange,
            onCityChange,
            onRegionChange,
            onRegionIdChange
        });
    }

    renderActions() {
        return (
            <button
              type={ FIELD_TYPE.submit }
              block="Button"
              mix={ { block: 'MyAccount', elem: 'Button' } }
            >
                { __('Save address') }
            </button>
        );
    }
}

export default MyAccountAddressFormComponent;
